import * as util from '#packages/util';

export const TEMPLATE_LIVE_VIEW_PREFIX =
  'https://www.wix.com/marketplace/template/view/live';

export const getCustomTemplateLearnMoreLink = () => {
  const langCode = util?.languages?.getLanguageCode() || 'en';

  return `https://support.wix.com/${langCode}/article/wix-studio-selling-your-custom-templates`;
};
